module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-41.49eb3479.png";